import * as React from 'react';
import { connect } from "react-redux";
import { KenticoFormContainer } from '../../containers/KenticoFormContainer';
import { LidZoekenHelpers } from '../pages/helpers/LidZoekenHelpers';
import { FormService } from '../../services/FormService';
import { clearLidZoeken, passthroughLidZoeken } from '../../actions/LidZoekenActions';
import { MijnFNVPageContext } from '../pages/helpers/MijnFNVPageContext';
import { getAllUrlParams } from '../../../jslibs/urlparams';
import * as actions from '../../actions/FormActions';
import { StringHelpers } from '../../helpers/StringHelpers';
import * as UrlHelper from '../../../core/utils/url-helpers';

export interface MijnFNVLidZoekenZoekerProps {
  
  editMode: boolean;
  formConfig: any;
  additionalCssClass: string;
  formName: string;
  pageType: string;
  formDefinitions: any;

  forms: any;
  lidZoeken: any;

  clearLidZoeken: () => void;
  setFormValues: (formName: string, values: any) => void;
  passthroughLidZoeken: (fieldName: string, value: any) => void;
}

export interface MijnFNVLidZoekenZoekerState {
  zoekenOp: string;
  lidnummer: string;  
  postcode: string;
  geboortedatum: string;
  huisnummer: string;
  searchValue: string;
  qrcode: string;
}


const mapStateToProps = (state : any) => {
  return {
      forms: state.forms,
      lidZoeken: state.lidZoeken
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {    
    clearLidZoeken: () => dispatch(clearLidZoeken()),
    setFormValues: (formName: string, values: any) => {
      dispatch(actions.storeFormValues(formName, values));
    },
    passthroughLidZoeken: (fieldName : string, value : any) => {
      dispatch(passthroughLidZoeken(fieldName, value));
    }
  };
};


export class MijnFNVLidZoekenZoekerContained extends React.Component<MijnFNVLidZoekenZoekerProps, MijnFNVLidZoekenZoekerState> {

  state = {
    zoekenOp : "",
    lidnummer : "",
    geboortedatum : "",
    postcode: "",
    huisnummer: "",
    searchValue: "",
    qrcode: "",
  };

  componentDidMount() {
    this.props.setFormValues("_formSubmitTrigger" , 
      {
        autoPost : false, 
        afterStoreValues: false
      });

    if (this.context && this.context.search) {
      let urlParams = getAllUrlParams(this.context.search);
      let geboorteDatum = "";
      if (urlParams.geboortedatum) {
        geboorteDatum = StringHelpers.convertDateToNL(urlParams.geboortedatum);
      }
      this.setState({
          lidnummer : urlParams.lidnummer || "",
          zoekenOp : urlParams.zoekenop || "",
          geboortedatum : geboorteDatum || "",
          postcode: urlParams.postcode || "",
          huisnummer: urlParams.huisnummer || "",
          searchValue: urlParams.searchvalue || ""          
        }, () => {
        this.props.setFormValues("_formSubmitTrigger" , 
          {
            autoPost : true,
            afterStoreValues: false 
          });
      });               
    }
    if (FormService.getIsInLidZoekenSubFunctions()) {
      FormService.setIsInLidZoekenSubFunctions(false);
    } else {
      if (this.props.lidZoeken.formName !== "MijnFNV_LidZoeken" && 
        	(this.props.lidZoeken.searchValue === undefined || 
          this.props.lidZoeken.searchValue === "" ||
          this.props.lidZoeken.formName !== this.props.formName)) {
        this.props.clearLidZoeken();
      }
    }
  }

  onFieldChange = (formName : string, fieldName : string, value : any) => {
    
    if (this.props.formConfig && this.props.formConfig.passthroughFieldsToGlobalState) {
      this.props.formConfig.passthroughFieldsToGlobalState.map((passThroughFieldName) => {
        if (passThroughFieldName === fieldName) {          
          this.props.passthroughLidZoeken(fieldName, value);
        }
      });
    }
  }

  render() {

    const formConfig = { ...this.props.formConfig };
    if(this.props.formName !== "MijnFNV_LidZoeken"){
      const queryParams: UrlHelper.IQueryParam[] = [{ key: 'pageNumber', value: 1 }];
      formConfig.postUrl = UrlHelper.addQueryParameters(formConfig.postUrl, queryParams);
    }
    formConfig.postPutMethod = 'post';
    formConfig.handlers = [...LidZoekenHelpers.getProcesses(formConfig)];
    
    return <>
      <KenticoFormContainer
        editMode={this.props.editMode}
        formConfig={formConfig}
        formDefinitions={this.props.formDefinitions}
        additionalCssClass={this.props.additionalCssClass}
        withLinkToFormPage={false}
        formName={this.props.formName}
        pageType={this.props.pageType}
        onFieldChange={this.onFieldChange}
        onOverrideGetFormValues={
            () => { 

              const zoekenOp = (this.props.forms[this.props.formName] && this.props.forms[this.props.formName]["ZoekenOp"]) || 
                this.props.lidZoeken.zoekenOp || this.state.zoekenOp || (formConfig.defaultSearch ? formConfig.defaultSearch : "lidnummer");
              const searchValue = this.props.lidZoeken.searchValue || this.state.searchValue || "";

              return {
                "ZoekenOp": zoekenOp,
                "Lidnummer": (this.props.forms[this.props.formName] && this.props.forms[this.props.formName]["Lidnummer"]) || 
                  this.props.lidZoeken.lidnummer || this.state.lidnummer || "",    
                "QRCode": (this.props.forms[this.props.formName] && this.props.forms[this.props.formName]["QRCode"]) ||
                  this.props.lidZoeken.qrcode || this.state.qrcode || "",  
                "Postcode": (this.props.forms[this.props.formName] && this.props.forms[this.props.formName]["Postcode"]) || 
                  this.props.lidZoeken.postcode || this.state.postcode || "",
                "Huisnummer": (this.props.forms[this.props.formName] && this.props.forms[this.props.formName]["Huisnummer"]) || 
                  this.props.lidZoeken.huisnummer || this.state.huisnummer || "",  
                "Geboortedatum": (this.props.forms[this.props.formName] && this.props.forms[this.props.formName]["Geboortedatum"]) || 
                  this.props.lidZoeken.geboortedatum || this.state.geboortedatum || "",
                [zoekenOp || "searchValue"] : searchValue
              };
            }
        }
      />
    </>;
  }

  static contextType = MijnFNVPageContext;
  context!: React.ContextType<typeof MijnFNVPageContext>;
}

export const MijnFNVLidZoekenZoeker = connect(mapStateToProps, mapDispatchToProps)(MijnFNVLidZoekenZoekerContained);
